// extracted by mini-css-extract-plugin
export default {"extraText":"ExtraText_extraText__TnygA"};